// extracted by mini-css-extract-plugin
module.exports = {"container":"Info_container__1THPY","firstInfo":"Info_firstInfo__2zPcp"};